import React from "react";
import { StyleSheet, View } from "react-native";
import { Button, Icon, Text } from "components";

import { mq } from "utils";
import { colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { IMessage } from "react-native-gifted-chat";

export default function ChatFooter(props: { msg: IMessage; hide: () => void }) {
  const { msg, hide } = props;
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  return (
    <View style={styles.container}>
      {/* <View
              style={{
                width: mq(10),
                height: '100%',
                backgroundColor: color,
              }}
            /> */}
      <Icon
        style={{ marginHorizontal: mq(5) }}
        type="fontIsTo"
        name="reply"
        size={25}
        color={color}
      />
      <View style={{ flex: 1 }}>
        <Text numberOfLines={1}>{msg?.text}</Text>
      </View>
      <Button
        onPress={hide}
        circle={40}
        bgColor={colors.transparent}
        icon={{ name: "x", color: colors.textColorDefault, size: 24 }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 60,
    backgroundColor: colors.lightButtons,
    flexDirection: "row-reverse",
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderColor: colors.info,
    overflow: "hidden",
    alignItems: "center",
  },
});
